import React from 'react'
import styled from 'styled-components'

import { isAdminDomain } from '../currentDomain'
import { UsageStatistics } from '../../common/redux/api/web-api'
import useText from '../../common/hooks/useText'

const StatBox = styled.div`
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 0;
`
const StatBoxNumber = styled.h2`
    font-weight: var(--font-weight-light);
    font-size: 44px;
    margin: 0;
`

const StatBoxText = styled.div`
    text-align: center;
    color: #535353;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: 15px;

    &.column {
        @media screen and (min-width: 992px) {
            flex-direction: column;
        }

        ${StatBox} {
            width: 50%;

            @media screen and (min-width: 992px) {
                width: 100%;
            }
        }
    }

    &.row {
        padding: 40px 100px 20px 100px;

        ${StatBox} {
            width: 50%;

            @media screen and (min-width: 992px) {
                width: inherit;
                border-bottom: 1px solid #f2f2f2;
            }
        }

        @media screen and (min-width: 992px) {
            justify-content: space-evenly;
        }
    }
`
type SingleStatBoxProps = {
    value?: number
    title: string
    dataTestId: string
}
const SingleStatBox = ({ value, title, dataTestId }: SingleStatBoxProps) => (
    <StatBox>
        <StatBoxNumber data-testid={`${dataTestId}-value`}>{value ?? '-'}</StatBoxNumber>
        <StatBoxText data-testid={dataTestId}>{title}</StatBoxText>
    </StatBox>
)

export function ChargingStatistics({ stats, direction }: ChargingStatisticsProps): React.ReactElement {
    const text = useText()

    return (
        <Wrapper className={direction} data-testid="statContainer">
            <SingleStatBox
                value={stats?.chargingSessionCount}
                title={text('lblTotalChargingSessions')}
                dataTestId="chargingSession"
            />
            <SingleStatBox
                value={stats?.averageChargingPerSession}
                title={isAdminDomain ? text('lblAverageChargedKWh') : text('lblAvgCharged')}
                dataTestId="avgChargingPerSession"
            />
            <SingleStatBox
                value={stats?.averageChargingTimeMinutes}
                title={text('lblAverageChargingTime')}
                dataTestId="avgChargingPerTime"
            />
            <SingleStatBox
                value={stats?.totalChargingTimeHours}
                title={text('lblTotalChargingTime')}
                dataTestId="totalTime"
            />
            <SingleStatBox value={stats?.totalConsumption} title={text('lblTotalChargedKWh')} dataTestId="totalKwH" />
        </Wrapper>
    )
}

export type ChargingStatisticsProps = {
    stats?: UsageStatistics
    direction: 'row' | 'column'
}
